const Constants = {
  URL: 'https://backend.emesmart.com',
  VERSION: 'v0.1'
};
export default Constants;
